module.exports = __webpack_public_path__ + "static/img/kefucode.af0ea4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/common/kefucode.jpg
// module id = cvMS
// module chunks = 0